import 'css-chunksrc/client/common/treeControls/styles.scss';export default {
  "treeControls": "_treeControls_1oyk2_1",
  "openAll": "_openAll_1oyk2_7",
  "closeAll": "_closeAll_1oyk2_8",
  "toggleArrow": "_toggleArrow_1oyk2_21"
};